import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/globals.css'

// Aplicar tema inicial antes de renderizar
const applyInitialTheme = () => {
  try {
    const storedTheme = localStorage.getItem('theme-storage');
    if (storedTheme) {
      const theme = JSON.parse(storedTheme);
      if (theme.state?.isDark) {
        document.documentElement.classList.add('dark');
      }
    } else {
      // Si no hay tema guardado, usar la preferencia del sistema
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        document.documentElement.classList.add('dark');
      }
    }
  } catch (error) {
    console.error('Error aplicando tema inicial:', error);
  }
};

// Aplicar tema antes de renderizar para evitar flash
applyInitialTheme();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)